// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","888":"course-setup","990":"venue-manager"}[chunkId] || chunkId) + "-legacy." + {"132":"3e5bc5eb","182":"877fd7e5","303":"43c6f8ce","354":"024f89c5","368":"144149d3","579":"107b3099","624":"8c633673","838":"3787910e","888":"024a3c12","990":"f507cfdd"}[chunkId] + ".js";
};